import React from 'react';
import PropTypes from 'prop-types';
import LegacyMedia from '../../LegacyMedia';
import { QuestionHeaderRow, EditorHeaderRowLeft, EditorHeaderRowRight, QuestionNumber, QuestionBody } from '../styles';

const QuizEditorHeader = ({ index = 0, children, headerRightPanel, headerText, legacyContent, removeLegacyMedia }) => {
  const header = headerText ? (
    <QuestionBody className="content-section" dangerouslySetInnerHTML={{ __html: headerText || '' }} />
  ) : (
    <QuestionBody className="content-section">{children}</QuestionBody>
  );

  const removeLegacyQuestionMedia = () => removeLegacyMedia(index);

  return (
    <QuestionHeaderRow>
      <EditorHeaderRowLeft isQuestion={true}>
        <QuestionNumber>{index + 1}</QuestionNumber>
        {legacyContent?.media_preview ? (
          <div>
            {header}
            <LegacyMedia item={legacyContent} onRemove={window.editor ? removeLegacyQuestionMedia : null} />
          </div>
        ) : (
          header
        )}
      </EditorHeaderRowLeft>
      <EditorHeaderRowRight isQuestion={true}>{headerRightPanel}</EditorHeaderRowRight>
    </QuestionHeaderRow>
  );
};

export default QuizEditorHeader;

QuizEditorHeader.propTypes = {
  index: PropTypes.number,
  children: PropTypes.object,
  headerRightPanel: PropTypes.object,
  headerText: PropTypes.string,
  legacyContent: PropTypes.object,
  removeLegacyMedia: PropTypes.func,
};
